import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/blog/[slug]/page.tsx");
